import { consoleTransport, transportFunctionType } from "react-native-logs";

const isLoggingSheet = async () => {
  let logSheetExists = false;
  await Excel.run(async (context) => {
    let sheets = context.workbook.worksheets;
    sheets.load("items/name");

    await context.sync();

    sheets.items.forEach(function (sheet) {
      if (sheet.name === "DR Log") {
        logSheetExists = true;
      }
    });
  });
  if (logSheetExists) {
    return true;
  } else {
    return false;
  }
};


// Mutex implementation for serializing excelSheetTransport calls
let excelSheetTransportMutex = Promise.resolve();

const excelSheetTransport = async (props) => {
  // Chain the new call to the mutex
  excelSheetTransportMutex = excelSheetTransportMutex.then(async () => {
    try {
      await Excel.run(async (context) => {
        let sheets = await context.workbook.worksheets;
        await context.sync();
        let sheet;
        let sheetCreated;

        if (!(await isLoggingSheet())) {
          sheet = sheets.add("DR Log");
          sheetCreated = true;
        } else {
          sheet = sheets.getItem("DR Log");
          sheetCreated = false;
        }

        await sheet.load("name, position");
        let dataRange = await sheet.getUsedRange(false);
        await dataRange.load();
        await context.sync();

        const dataRangeLength = await dataRange.values.length;

        let nextFreeCellIndex = 1;

        if (sheetCreated) {
          nextFreeCellIndex = 1;
        } else {
          if (dataRangeLength === 1 && dataRange.values[0][0] === "") {
            nextFreeCellIndex = 1;
          } else {
            nextFreeCellIndex = dataRangeLength + 1;
          }
        }
        const dateTime = props.msg.split("|");
        // Use for...of to ensure sequential writes
        for (let i = 0; i < props.rawMsg.length; i++) {
          const log = props.rawMsg[i];
          const levelText = props.level && props.level.text ? props.level.text.toUpperCase() : "";
          let writeRange = await sheet.getRange(`A${nextFreeCellIndex + i}:D${nextFreeCellIndex + i}`);
          writeRange.values = [[dateTime[0], levelText, "Taskpane", log]];
        }
      });
    } catch (err) {
      console.error("excelSheetTransport error:", err);
    }
  });
  // Wait for the current call to finish before returning
  await excelSheetTransportMutex;
};

const customTransport: transportFunctionType<{ myCustomOption: string }> = (props) => {
  excelSheetTransport(props);
};

export const loggerConfig = {
  levels: {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
  },
  severity: "info",
  transport: [
    consoleTransport,
    customTransport,
  ],
  async: false, // This might bring performance boosts, but at same case it might cause some issues.
  dateFormat: "iso",
  printLevel: true,
  printDate: true,
  fixedExtLvlLength: false,
  enabled: false, // This is set to false by default, but can be switched true in the app.
};
